import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  // Use const for state hooks
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Guard against environments where window is not defined (e.g., SSR)
    if (typeof window === 'undefined') {
      return;
    }

    const handleScroll = () => {
      // Ensure scrollY is a number before comparison
      const scrollY = typeof window.scrollY === 'number' ? window.scrollY : 0;
      setIsScrolled(scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-brand-cream/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer order-first"
            aria-label="Toggle menu"
          >
            <i
              className={`ri-menu-line text-2xl transition-colors duration-300 ${
                isScrolled ? 'text-brand-charcoal' : 'text-white'
              }`}
            ></i>
          </button>

          {/* Centered Logo */}
          <Link to="/" className="flex items-center justify-center cursor-pointer md:absolute md:left-1/2 md:transform md:-translate-x-1/2">
            <div className="w-32 h-32 md:w-48 md:h-48 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/46486837f23a407fc30fe3f1b69bedea/461c4c3ffb35eb0929332de1db251636.png"
                alt="The Injector Syd"
                className="w-full h-full object-contain drop-shadow-lg"
              />
            </div>
          </Link>

          {/* Right - Book Button (Desktop) */}
          <div className="hidden md:flex items-center justify-end flex-1">
            <a
              href="tel:+17022835858"
              className={`px-6 py-3 font-sans text-xs font-semibold tracking-[0.15em] uppercase transition-all duration-300 cursor-pointer whitespace-nowrap rounded-sm ${
                isScrolled
                  ? 'bg-brand-blush text-white hover:bg-brand-rose'
                  : 'bg-white/20 backdrop-blur-sm text-white border border-white/40 hover:bg-white hover:text-brand-charcoal'
              }`}
            >
              Book Now
            </a>
          </div>

          {/* Mobile Book Button */}
          <a
            href="tel:+17022835858"
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-full transition-all duration-300 ${
              isScrolled
                ? 'bg-brand-blush text-white'
                : 'bg-white/20 backdrop-blur-sm text-white'
            }`}
            aria-label="Book Now"
          >
            <i className="ri-phone-line text-lg"></i>
          </a>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-brand-cream shadow-xl">
          <nav className="flex flex-col p-8 space-y-6">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="font-sans text-xs font-semibold tracking-[0.25em] uppercase text-brand-charcoal hover:text-brand-blush cursor-pointer transition-colors"
            >
              Home
            </Link>
            <Link
              to="/menu"
              onClick={() => setIsMobileMenuOpen(false)}
              className="font-sans text-xs font-semibold tracking-[0.25em] uppercase text-brand-charcoal hover:text-brand-blush cursor-pointer transition-colors"
            >
              Menu
            </Link>
            <a
              href="tel:+17022835858"
              onClick={() => setIsMobileMenuOpen(false)}
              className="inline-block px-8 py-4 bg-brand-blush text-white font-sans text-xs font-semibold tracking-[0.15em] uppercase hover:bg-brand-rose transition-colors whitespace-nowrap cursor-pointer rounded-sm text-center"
            >
              Book Now
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}